import React from "react"
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next"
import { ListItem } from "../checkout/ListItem"
import { BodyTextRegular, BodyTextSemibold } from "../typography/text"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { getFormattedLanguage } from "../../util/languageUtil"
import { translationKeys } from "../../util/translationKeys"
import { DialogModal } from "../Dialog"
import { setHTMLTagLang } from "../../util/util"

type Props = {
  isVisible: boolean
  hideModal: () => void
}

const getTitle = (title: string) => {
  return (
    <BodyTextSemibold className="text-textPrimary">
      {getFormattedLanguage(title)}
    </BodyTextSemibold>
  )
}

export const LanguagePickerModal = ({ isVisible, hideModal }: Props) => {
  const { languages, changeLanguage, language } = useI18next()
  const { t } = useTranslation()

  const onClick = (lang: string) => {
    changeLanguage(lang)
    setHTMLTagLang(lang)
    hideModal()
  }

  return (
    <DialogModal
      title={`${t(translationKeys.webChooseLanguage)}`}
      isOpen={isVisible}
      onClose={hideModal}
    >
      <div className="flex flex-col gap-2 px-6 py-4">
        {languages
          .sort((a, b) => {
            if (a == language) {
              return -1
            } else if (b == language) {
              return 1
            } else {
              return a.localeCompare(b)
            }
          })
          .map((lang, index) => (
            <ListItem
              key={index}
              Title={getTitle(lang)}
              type="choose"
              onClick={() => onClick(lang)}
              Left={
                <div className="flex items-center justify-center rounded w-6 h-6 min-h-6 max-w-6 bg-ctaLight">
                  <BodyTextSemibold className="text-ctaMain">
                    <FontAwesomeIcon icon={solid("globe")} />
                  </BodyTextSemibold>
                </div>
              }
              Right={
                lang === language ? (
                  <BodyTextRegular className="text-textPrimary">
                    <FontAwesomeIcon icon={solid("check")} />
                  </BodyTextRegular>
                ) : (
                  <div className="choose-button">
                    <BodyTextRegular>
                      {t(translationKeys.webChoose)}
                    </BodyTextRegular>
                  </div>
                )
              }
            ></ListItem>
          ))}
      </div>
    </DialogModal>
  )
}
